"use strict";
// import "doshx_controls_web/lib/index.css"; //Tailwind is being included here.
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const client_1 = require("react-dom/client");
const app_1 = require("./app");
require("./helpers/testHelpers"); // Load test helpers for console access
const root = (0, client_1.createRoot)((_a = document.getElementById("app")) !== null && _a !== void 0 ? _a : document.body);
root.render(react_1.default.createElement(app_1.App, null));
